<template>
  <div>
    <vs-popup :title="$t('CreateSerial')" :active.sync="showModal">
      <!-- <form> -->
      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <vx-card v-if="show">
            <vs-tabs vs-alignment="fixed" alignment="fixed" ref="Tabs">
              <vs-tab label="درج به صورت تجمیعی" class="mt-1">
                <start-counting-with-textarea-popup
                  :countingTagId="countingTagId"
                  :countingGroupId="countingGroupId"
                  @finish="$emit('close')"
                ></start-counting-with-textarea-popup>
              </vs-tab>
              <vs-tab label="درج به صورت لیست" class="mt-1">
                <start-counting-with-list-popup
                  :countingTagId="countingTagId"
                  :countingGroupId="countingGroupId"
                  @finish="$emit('close')"
                ></start-counting-with-list-popup>
                <!-- <review-queue
                :tabIndex="1"
                v-if="isRender[1]"
                :numberRowsPerPage="numberRowsPerPage"
              ></review-queue> -->
              </vs-tab>
            </vs-tabs>
          </vx-card>
          <!-- <vs-textarea
            v-model="serialInTextarea"
            name="Description"
            :label="$t('SerialNumber')"
            rows="10"
          /> -->
          <!-- <table class="basic-tbl">
            <thead>
              <tr>
                <th style="width: 10%">#</th>
                <th style="width: 10%;color:black">{{ $t("SerialNumber") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="i in counterList"
                :key="i"
                style="border:1px solid #e0dede;"
                class="m-0 p-0"
              >
                <td
                  style="width: 10%"
                  class="m-0 p-0"
                  :class="isDuplicateBarcode ? 'duplicate-class' : ''"
                >
                  {{ i }}
                </td>
                <td style="width: 90%" class="m-0 p-0">
                  <vs-input
                    class="inputx m-0 p-0 "
                    style="border:none;outline:none "
                    v-model="serials[i - 1]"
                    :id="'serial' + i"
                    @keyup.enter="nextSerial(i)"
                  />
                </td>
              </tr>
            </tbody>
          </table> -->
        </div>
      </div>
      <!-- </form> -->
      <!-- <vs-button
        type="filled"
        class="float-right mb-4"
        @click.prevent="submitSerialForm"
        >{{ $t("Save") }}</vs-button
      > -->
    </vs-popup>
  </div>
</template>
<style lang="scss">
.vs-con-input input {
  text-align: right;
}
.custom-tbl td {
  padding: 0.5rem 1rem !important;
}
.duplicate-class {
  background-color: white;
  animation-name: DuplicateBarcode;
  animation-duration: 0.5s;
}
@keyframes DuplicateBarcode {
  from {
    background-color: white;
  }
  to {
    background-color: red;
  }
}
</style>
<script>
import { mapActions } from "vuex";
import StartCountingWithTextareaPopup from "./StartCountingWithTextareaPopup";
import StartCountingWithListPopup from "./StartCountingWithListPopup";

export default {
  name: "warehouseManagement_CheckOutTransactions_SerialPopup",
  components: {
    StartCountingWithTextareaPopup,
    StartCountingWithListPopup,
  },
  props: {
    show: { default: false },
    countingTagId: { default: "" },
    countingGroupId: { default: "" },
  },
  data() {
    return {
      serialsString: "",
      serialInTextarea: "",
      model: {},
      modelForList: {},
      serials: [],
      allInputElement: [],
      counterList: 15,
      isDuplicateBarcode: false,
    };
  },

  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
        this.$validator.reset();
      },
    },
  },
  methods: {
    ...mapActions({
      submitListSerials: "warehouseHandling/submitListSerials",
      fetchListBarcode: "warehouseHandling/fetchListBarcode",
    }),
    getAllSubmitedBarcode() {
      this.fetchListBarcode(this.modelForList).then((r) => {
        this.counterList += r.length;
        r.forEach((elem) => {
          this.serials.push(elem.serial);
        });
        setTimeout(() => {
          this.allInputElement = document.querySelectorAll('*[id^="serial"]');
          var elem = document.getElementById(
            "serial" + (this.serials.length + 1)
          );
          elem.focus();
        }, 200);
      });
    },
    // addSerial() {
    //   setTimeout(() => {
    //     if (this.serial) {
    //       this.index++;
    //       this.Items.unshift({
    //         serial: this.serial,
    //         index: this.index
    //       });
    //       this.serial = "";
    //       this.updateGrid();
    //     }
    //   }, 150);
    // },
    submitSerialForm() {
      let tempSerialsString = "";
      this.serialInTextarea.split("\n").forEach((elem) => {
        tempSerialsString += elem + ",";
      });
      this.serialsString = tempSerialsString.slice(
        tempSerialsString,
        length - 3
      );
      this.model = {
        countingTagId: Number(this.countingTagId),
        countingGroupId: this.countingGroupId,
        serialsItems: this.serialsString,
      };
      this.submitListSerials(this.model).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
          showConfirmButton: false,
          timer: 2000,
        });
        this.$emit("finish");
      });
    },

    // submitSerialForm() {
    //   this.serials.forEach(elem => {
    //     if (elem) {
    //       this.serialsString += elem;
    //       this.serialsString += ",";
    //     }
    //   });
    //   this.serialsString = this.serialsString.slice(0, -1);
    //   this.model = {
    //     countingTagId: Number(this.countingTagId),
    //     countingGroupId: this.countingGroupId,
    //     serialsItems: this.serialsString
    //   };
    //   this.submitListSerials(this.model).then(() => {
    //     this.$emit("finish");
    //   });
    // },
    nextSerial(i) {
      if (this.serials[i - 1]) {
        this.isDuplicateBarcode = false;
        for (let index = 0; index < this.serials.length - 1; index++) {
          if (this.serials[this.serials.length - 1] == this.serials[index]) {
            this.isDuplicateBarcode = true;
            this.serials[this.serials.length - 1] = "";
            break;
          }
        }
        if (!this.isDuplicateBarcode) {
          if (i == 1 || this.counterList - i == 15) {
            this.allInputElement = document.querySelectorAll('*[id^="serial"]');
          }
          this.allInputElement[i].focus();
          if (this.counterList - i <= 1) {
            this.counterList += 15;
          }
        } else {
          this.allInputElement[i - 1].focus();
        }
      }
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.Items = [];
        this.index == 0;
        // this.modelForList = {
        //   idTag: this.countTagId,
        //   idGroup: this.countGroupId
        // };
        // this.getAllSubmitedBarcode();
      }
    },
  },
};
</script>
